module.exports = __webpack_public_path__ + "img/thankyoucard.fc84533e.png";